import React from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider, connect} from 'react-redux'
import reducerMaster from './Reducers/reducerMaster';
import Master from './Containers/Master'

import DatenJSON from './Store/DatenJSON';
import KonfigurationJSON from './Store/KonfigurationJSON';


let searchParams = new URLSearchParams(window.location.search);
if (searchParams.has('form')) {
  DatenJSON.antragstyp = searchParams.get('form')
}

if (searchParams.has('debug')) {
  DatenJSON.debug = true
}

const store = createStore (
  reducerMaster,
  {
    daten:DatenJSON,
    konfiguration:KonfigurationJSON,
  },
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
)

const mapStateToProps = (state) => {
  return {
    store: state
  }
}

const Index = connect (
  mapStateToProps
)(Master);

ReactDOM.render(
  <Provider store={store}>
    <Index />
  </Provider>,
  document.getElementById('app')
);